<template>
    <div>
        <h1>{{item.name}}</h1>
        <table>
            <tbody>
                <td>{{item.type}}</td>
                <td></td>

            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: 'ProjectItem',
    props: ['item']
}
</script>

<style scoped>
h1{
    text-align: center;
    font-size: 35px;
    line-height: 70px;
    font-family: "Snell Roundhand", "cursive";
    font-weight: bold;
}
h2{
    text-align: center;
    font-style: 18px;
}
table{
    margin: 20px;
}
td{
    font-size: 18px;
    line-height: 2;
}
td:first-child{
    text-align: right;
    font-weight: bold;
    padding: 0 20px;
}
</style>